

import { initializeApp } from "firebase/app";

import { getAuth } from "firebase/auth";

const firebaseConfig = {

  apiKey: "AIzaSyAPZcK-7XsrY8Uv6nNhNiiAoHBFxTFpaw0",
  authDomain: "felahlinkauthentification.firebaseapp.com",
  projectId: "felahlinkauthentification",
  storageBucket: "felahlinkauthentification.firebasestorage.app",
  //storageBucket:"felahlinkauthentification.appspot.com",
  messagingSenderId: "978306717294",
  appId: "1:978306717294:web:d7734bdaa116f23068b87f"

};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export default app;